<template>
  <div class="navigation">
    <el-tabs v-model="activeName" @tab-click="handkeClick" class="tabs">
      <el-tab-pane label="项目管理" name="first">
        <el-form :inline="true">
          <el-form-item class="one">
            <el-input placeholder="搜索项目" v-model="project.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="search" class="btn-submit">搜索</el-button>
            <el-button @click="emty" class="btn-emty">清除搜索</el-button>
          </el-form-item>
          <el-form-item class="but">
            <el-button class="btn-submit2" icon="el-icon-plus" @click="jumedit()">添加项目</el-button>
            <el-button @click="alldeleteColumn" class="btn-del2">批量删除
            </el-button
            >
          </el-form-item>
          <el-table
            :data="tableData"
            :header-cell-style="{background:'#f5f5f5',color:'rgb(82,82,82)',fontSize:'16px',fontWeight:400}"
            ref="multipleTable"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            class="tvall"
          >
            <el-table-column width="60" align="center" type="selection">
            </el-table-column>
            <el-table-column label="项目名称" align="center" prop="name">
            </el-table-column>
            <el-table-column label="项目描述" align="center" prop="describe">
            </el-table-column>
            <el-table-column label="参与人数" align="center" prop="users">
            </el-table-column>
            <el-table-column label="创建人" align="center" prop="creator_name">
            </el-table-column>
            <el-table-column label="所属分组" align="center" prop="group_name">
            </el-table-column>
            <el-table-column v-if="dept_id==0" label="归档团队" align="center" prop="dept_name">
            </el-table-column>
            <el-table-column label="协同负责人" align="center" prop="xietongren">
              <template slot-scope="scope">
              <span v-for="item in users"  v-if="item.id == scope.row.xietongren">
                <span>{{item.name}}</span>
              </span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center" prop="created_at" width="200">
            </el-table-column>
            <el-table-column label="状态" align="center" prop="status">
              <template slot-scope="scope">
                <span>{{scope.row.status == 0 ? '无' : scope.row.status == 1 ? '洽谈中' :scope.row.status ==2?'报告撰写':scope.row.status ==3?'售后服务':scope.row.status ==4?'项目受阻':'结束'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="220">
              <template slot-scope="scope">
                <div v-if="rulename=='administrator'">
                  <span class="nav" v-if="scope.row.status == 5" @click="jumpToItem(scope.$index,scope.row)"><i class="el-icon-bianji"></i>查看</span>
                  <span v-if="scope.row.status == 5">|</span>
                  <span class="nav" @click="jumedit(scope.$index,scope.row)"><i class="el-icon-bianji"></i>修改</span>
                  <span>|</span>
                  <span class="nav" @click="deleteColumn(scope.$index, scope.row)" style="color:red"><i
                    class="el-icon-delete"></i>删除</span>
                </div>
                <div v-else>
                  <span class="nav" v-if="scope.row.status == 5" @click="jumpToItem(scope.$index,scope.row)"><i class="el-icon-bianji"></i>查看</span>
                  <span v-if="scope.row.status == 5 && ( user==scope.row.creator_name || userID == scope.row.xietongren)">|</span>
                  <span v-if=" user==scope.row.creator_name || userID == scope.row.xietongren" class="nav" @click="jumedit(scope.$index,scope.row)"><i
                    class="el-icon-bianji"></i>修改</span>
                  <span v-if=" user==scope.row.creator_name || userID == scope.row.xietongren">|</span>
                  <span v-if=" user==scope.row.creator_name || userID == scope.row.xietongren" class="nav" @click="deleteColumn(scope.$index, scope.row)"
                        style="color:red"><i class="el-icon-delete"></i>删除</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <Pagination
            v-if="total > 0"
            :currentPage="currentPage"
            :total="total"
            :limit="limit"
            @handleCurrentChange="handleCurrentChange"
          ></Pagination>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="分组管理" name="second">
        <el-button
          class="btn-submit"
          @click="groupClumn"
          style="margin-bottom: 20px"
          icon="el-icon-plus"
        >新增
        </el-button
        >
        <el-table
          :header-cell-style="{background:'#f5f5f5',color:'rgb(82,82,82)',fontSize:'16px',fontWeight:400}"
          :data="tableData1"
        >
          <el-table-column
            label="组名"
            align="center"
            prop="name"
          ></el-table-column>
          <el-table-column
            label="下属项目个数"
            align="center"
            prop="projects"
          ></el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
            prop="updated_at"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope" v-if="rulename=='administrator'">
              <span @click="groupClumn(scope.$index, scope.row)" class="nav"><i class="el-icon-bianji"></i>修改</span>
              |
              <span @click="deleteColumn2(scope.$index, scope.row)" class="nav" style="color:red"><i
                class="el-icon-delete"></i>删除</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 增加和修改 -->
        <div>
          <el-dialog
            :title="title1"
            :visible.sync="editFormVisible1"
            class="edit-dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <el-divider></el-divider>
            <el-form ref="group" :rules="rules" :model="group">
              <el-form-item label="组名" prop="slug">
                <el-input v-model="group.slug"></el-input>
              </el-form-item
              >
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button
                class="btn-submit"
                type="primary"
                @click="groupFrom('group')"
              >确定
              </el-button
              >
              <el-button class="btn-cancel" @click="editFormVisible1 = false"
              >取消
              </el-button
              >
            </div>
          </el-dialog>
        </div>
        <!-- 分页组件 -->
        <Pagination
          v-if="total2 > 0"
          :currentPage="currentPage2"
          :total="total2"
          :limit="limit2"
          @handleCurrentChange="handleCurrentChange1"
        ></Pagination>
      </el-tab-pane>
      <el-tab-pane label="状态管理" name="third">
        <el-button
          class="btn-submit"
          @click="editCloumn"
          style="margin-bottom: 20px"
          icon="el-icon-plus"
        >新增
        </el-button
        >
        <el-table
          :header-cell-style="{background:'#f5f5f5',color:'rgb(82,82,82)',fontSize:'16px',fontWeight:400}"
          :data="tableData2"
        >
          <el-table-column label="状态名" align="center" prop="name">
          </el-table-column>
          <el-table-column label="颜色状态" align="center" prop="name">
            <template slot-scope="scope">
              <el-color-picker
                v-model="scope.row.color"
                size="mini"
                disabled
              ></el-color-picker>
              <!-- {{scope.row.name == '已完成' ? "已完成" : scope.row.name == '阻塞' ? '阻塞' : scope.row.name == '进行中' ? '进行中' : '未开始'
              }} -->
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
            prop="created_at"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.id>3">
                <span @click="editCloumn(scope.$index, scope.row)" class="nav">
                <i class="el-icon-bianji"></i>编辑</span
                >
                |
                <span @click="deleteColumn3(scope.$index, scope.row)" class="nav" style="color:red"><i
                  class="el-icon-delete"></i>删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 修改和增加 -->
        <div>
          <el-dialog
            :title="title"
            :visible.sync="editFormVisible"
            class="edit-dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <el-divider></el-divider>
            <el-form ref="status" :rules="rules" :model="status">
              <el-form-item label="状态名称" prop="name">
                <el-input v-model="status.name"></el-input>
              </el-form-item
              >
              <br/>
              <el-form-item>
                <template>
                  <el-color-picker
                    v-model="status.color"
                    :popper-append-to-body="false"
                    popper-class="color1"
                  ></el-color-picker>
                </template>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button
                class="btn-submit"
                type="primary"
                @click="addFrom('status')"
              >确定
              </el-button
              >
              <el-button class="btn-cancel" @click="editFormVisible = false"
              >取消
              </el-button
              >
            </div>
          </el-dialog>
        </div>
        <!-- 分页组件 -->
        <Pagination
          v-if="total > 0"
          :currentPage="currentPage3"
          :total="total3"
          :limit="limit3"
          @handleCurrentChange="handleCurrentChange2"
        ></Pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Pagination from "../../components/Pagination";
  import {
    getprojects,
    deleteaproject,
    getgroups,
    deleteagroup,
    getstatuss,
    deletestatus,
    updatestatus,
    addstatus,
    updategroup,
    addgroup, getUserList,

  } from "../../api/setting";

  export default {
    name: "children",
    inject: ["reload"],
    data() {
      return {
        //选中的部门id
        dept_id: localStorage.getItem('dept_id'),
        collapsed: true,
        editFormVisible: false,
        editFormVisible1: false,
        editFormVisible2: false,
        title: "创建状态",
        title1: "创建分组",
        isIndeterminate: true,
        checkAll: false,

        //搜索框
        project: {
          name: "",
        },
        //table数据
        tableData: [],
        tableData1: [],
        tableData2: [],
        //复选框选中值
        multipleSelection: [],
        currentPage: 1,
        currentPage2: 1,
        currentPage3: 1,
        total: 1,
        limit: 10,
        total2: 1,
        limit2: 10,
        total3: 1,
        limit3: 10,
        activeName: "first",
        user: localStorage.getItem("name"),
        userID:localStorage.getItem('userId'),
        rulename: localStorage.getItem('roleName'),
        users: [],
        //状态
        status: {
          statu_name: "",
          name: "",
          statu_color: "",
          color: "",
          id: "",
          addname: "",
          addcolor: "",
        },
        //分组
        group: {
          id: "",
          name: "",
          slug: "",
        },
        rules: {
          slug: [{required: true, message: "请输入组名", trigger: "change"}],
          name: [
            {required: true, message: "请输入状态名称", trigger: "change"},
          ],
          // phone:[{required:true,message: '请输入手机号码', trigger: 'change'}],
        },
      };
    },

    // 注册组件
    components: {
      Pagination,
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      async re() {
        this.reload();
      },
      //获取项目列表
      getData() {
        let params = {
          token: localStorage.getItem("token"),
          page: this.currentPage,
        };
        getprojects(params).then((res) => {
          // console.log(res);
          if (res.errno === 0) {
            this.tableData = res.data.data;
            console.log(this.tableData)
            this.limit = res.data.per_page
            this.total = res.data.total
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.errno);
          }
        });
      },
      search() {
        let params = {
          token: localStorage.getItem("token"),
          name: this.project.name,
          page: this.currentPage,
        };
        getprojects(params).then((res) => {
          if (res.errno === 0) {
            this.tableData = res.data.data;
            this.limit = res.data.per_page
            this.total = res.data.total
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.errno);
          }
        });
      },
      getgroup() {
        let params = {
          token: localStorage.getItem("token"),
          page: this.currentPage2,
        };
        getgroups(params).then((res) => {
          if (res.errno === 0) {
            this.tableData1 = res.data.data;
            this.limit2 = res.data.per_page
            this.total2 = res.data.total
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.errno);
          }
        });
      },
      getstatu() {
        let params = {
          token: localStorage.getItem("token"),
          page: this.currentPage3,
        };
        getstatuss(params).then((res) => {
          if (res.errno === 0) {
            this.tableData2 = res.data.data;
            this.limit3 = res.data.per_page
            this.total3 = res.data.total
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.errno);
          }
        });
      },
      deleteColumn(index, row) {
        this.$confirm("确定要删除该项目吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              token: localStorage.getItem("token"),
              id: row.id,
            };
            deleteaproject(params)
              .then((res) => {
                if (res.errno === 0) {
                  this.$message({
                    type: "success",
                    message: res.data,
                  });
                  this.getData();
                  this.re();
                } else if (res.errno === 401) {
                  this.$store.dispatch("LogOut").then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                  });
                } else {
                  this.$message.error(res.data);
                }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败，请稍后再试！");
              });
          })
          .catch((err) => {
            this.loading = false;
          });
      },
      alldeleteColumn(index, row) {
        this.$confirm("确定要删除这些项目吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              token: localStorage.getItem("token"),
              id: this.multipleSelection.join(","),
            };
            if (
              this.multipleSelection.length == "" ||
              this.multipleSelection == undefined
            ) {
              this.$message.error("请选择要删除的项目");
            } else {
              // console.log(this.multipleSelection);
              deleteaproject(params).then((res) => {
                if (res.errno === 0) {
                  this.$message({
                    type: "success",
                    message: res.data,
                  });
                  this.getData();
                  this.re()
                } else if (res.errno === 401) {
                  this.$store.dispatch("LogOut").then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                  });
                } else {
                  this.$message.error(res.data);
                }
              })
                .catch((err) => {
                  this.loading = false;
                  this.$message.error("删除失败，请稍后再试！");
                });
            }
          })
          .catch((err) => {
            this.loading = false;
          });
      },
      //  toggle1(showtype) {
      //   this.collapsed = !showtype;
      //   this.$root.Bus.$emit("toggle1", this.collapsed);
      // },
      deleteColumn2(index, row) {
        this.$confirm("确定要删除该项目吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              token: localStorage.getItem("token"),
              id: row.id,
            };
            deleteagroup(params)
              .then((res) => {
                if (res.errno === 0) {
                  this.$message({
                    type: "success",
                    message: res.data,
                  });
                  this.getgroup();
                } else if (res.errno === 401) {
                  this.$store.dispatch("LogOut").then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                  });
                } else {
                  this.$message.error(res.data);
                }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败，请稍后再试！");
              });
          })
          .catch((err) => {
            this.loading = false;
          });
      },
      deleteColumn3(index, row) {
        this.$confirm("确定要删除该项目吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              token: localStorage.getItem("token"),
              id: row.id,
            };
            deletestatus(params)
              .then((res) => {
                if (res.errno === 0) {
                  this.$message({
                    type: "success",
                    message: res.data,
                  });
                  this.getstatu();
                } else if (res.errno === 401) {
                  this.$store.dispatch("LogOut").then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                  });
                } else {
                  this.$message.error("res.errno");
                }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败，请稍后再试！");
              });
          })
          .catch((err) => {
            this.loading = false;
          });
      },
      // 修改和增加状态
      editCloumn(index, row) {
        this.editFormVisible = true;
        if (row == "" || row == undefined) {
          this.title = "创建状态";
          this.status.id = "";
          this.status.name = "";
          this.status.color = "";
        } else {
          this.title = "修改状态";
          this.status.id = row.id;
          this.status.name = row.name;
          this.status.color = row.color;
        }
      },
      //确定修改和增加状态
      addFrom(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.status.id == "") {
              if (this.status.color == "") {
                this.$message.error("请添加颜色");
              } else {
                let params = {
                  token: localStorage.getItem("token"),
                  name: this.status.name,
                  color: this.status.color,
                };
                addstatus(params).then((res) => {
                  if (res.errno === 0) {
                    this.$message({
                      type: "success",
                      message: res.data,
                    });
                    this.editFormVisible = false;
                    this.getstatu();
                  } else if (res.errno === 401) {
                    this.$store.dispatch("LogOut").then(() => {
                      location.reload(); //为了重新实例化vue-router对象 避免bug
                    });
                  } else {
                    this.$message.error(res.error);
                  }
                });
              }
            } else {
              let params = {
                token: localStorage.getItem("token"),
                id: this.status.id,
                name: this.status.name,
                color: this.status.color,
              };
              updatestatus(params).then((res) => {
                if (res.errno === 0) {
                  this.$message({
                    type: "success",
                    message: res.data,
                  });
                  this.getstatu();
                  this.editFormVisible = false;
                } else if (res.errno === 401) {
                  this.$store.dispatch("LogOut").then(() => {
                    location.reload(); //为了重新实例化vue-router对象 避免bug
                  });
                } else {
                  this.$message.error(res.error);
                }
              });
            }
          }
        });
      },
      //增加分组
      groupClumn(index, row) {
        this.editFormVisible1 = true;
        if (row == "" || row == undefined) {
          this.title1 = "创建分组";
          this.group.slug = "";
          this.group.id = "";
        } else {
          this.title1 = "编辑分组";
          this.group.slug = row.name;
          this.group.id = row.id;
        }
      },
      groupFrom(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.group.id == "") {
              let params = {
                token: localStorage.getItem("token"),
                name: this.group.slug,
              };
              addgroup(params).then((res) => {
                if (res.errno === 0) {
                  this.$message({
                    type: "success",
                    message: res.data,
                  });
                  this.getgroup();
                  this.editFormVisible1 = false;
                } else if (res.errno === 401) {
                  this.$store.dispatch("LogOut").then(() => {
                    location.reload(); //为了重新实例化vue-router对象 避免bug
                  });
                } else {
                  this.$message.error(res.error);
                }
              });
            } else {
              let params = {
                id: this.group.id,
                token: localStorage.getItem("token"),
                name: this.group.slug,
              };
              updategroup(params).then((res) => {
                if (res.errno === 0) {
                  this.$message({
                    type: "success",
                    message: res.data,
                  });
                  this.editFormVisible1 = false;
                  this.getgroup();
                  this.re();
                } else if (res.errno === 401) {
                  this.$store.dispatch("LogOut").then(() => {
                    location.reload(); //为了重新实例化vue-router对象 避免bug
                  });
                } else {
                  this.$message.error(res.error);
                }
              });
            }
          }
        });
      },
      //增加状态
      handkeClick(tab, event) {
        // console.log(tab, event);
      },
      //获取用户列表
      getUser() {
        let params = {
          token: localStorage.getItem("token"),
          is_all: 1
        };
        getUserList(params).then((res) => {
          if (res.errno === 0) {
            this.users = res.data
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.error);
          }
        });
      },
      //清空搜索
      emty() {
        this.project.name = "";
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getData();
      },
      handleCurrentChange1(val) {
        this.currentPage2 = val;
        this.getgroup();
      },
      handleCurrentChange2(val) {
        this.currentPage3 = val;
        this.getstatu();
      },
      handleSelectionChange(val) {
        // console.log(val);
        this.multipleSelection = [];
        for (var i in val) {
          this.multipleSelection.push(val[i].id);
        }
        // this.multipleSelection = val;
        // console.log(this.multipleSelection.join(","));
      },
      jumedit(index, row) {
        if (row == undefined || row == '') {
          this.$router.push({path: "/setting/addproject"});
        } else {
          this.$router.push({path: "/setting/addproject", query: {id: row.id}});
        }
      },
      jumpToItem(index, row) {
          this.$router.push({path: "/myproject/itemOne", query: {id: row.id}});
      },
    },
    mounted() {
      this.dept_id = localStorage.getItem('dept_id')
      this.getData();
      this.getgroup();
      this.getstatu();
      this.getUser()
    },
  };
</script>

<style scoped>
  /* .navigation{
    padding: 10px;

  } */
  .tabs >>> .el-tabs__nav-scroll {
    background-color: #ffffff;
  }

  /* .tabs>>>.index-main{

  } */
  .edit-dialog >>> .el-dialog {
    width: 25%;
  }

  .nav {
    cursor: pointer;
    color: #2b52e9;
    margin-right: 8px;
  }

  .nav i {
    margin-right: 5px;
    margin-left: 8px;
  }

  .edit-dialog >>> .el-dialog__body {
    padding-top: 0px;
    /* padding-bottom: 80px; */
  }

  .edit-dialog >>> .el-color-picker__trigger {
    width: 120px;
  }

  .tvall
  >>> .el-table__header
  .el-table-column--selection
  .cell
  .el-checkbox:after {
    color: #909399;
    content: "全选";
    font-size: 14px;
    margin-left: 7px;
    font-weight: bold;
  }


  .but {
    float: right;
  }

  .navigation >>> .el-tabs__header {
    padding-left: 30px;
    background-color: #ffffff;
  }

  .navigation >>> .el-tabs__nav-wrap::after {
    content: "";
    background-color: revert;
  }

  .navigation >>> .el-tabs__nav {
    height: 60px;
  }

  .navigation >>> .el-tabs__item.is-active {
    color: #141464;
    font-size: 17px;
    font-weight: 700;
  }

  .navigation >>> .el-tabs__item {
    color: #666666;
  }

  .navigation >>> .el-tabs__active-bar {
    background-color: #2b52e9;
  }

  .navigation >>> .el-tabs--top .el-tabs__item.is-top:last-child {
    padding-right: 0;
    height: 60px;
    line-height: 60px;
  }

  .navigation >>> .el-tabs__item {
    font-size: 16px;
  }

  /*间距*/
  .navigation >>> .el-row {
    margin-top: 25px;
  }

  .el-row {
    margin-bottom: 20px;
  }

  .el-row:last-child {
    margin-bottom: 0;
  }

  .one >>> .el-input__inner {
    width: 394px;
    height: 32px;
    color: #999999;
    font-size: 12px;
    border: 1px solid #cccccc;
  }

  .edit-dialog >>> .el-input__inner {
    /* width: ; */
    font-size: 12px;
    color: #999999;
    height: 32px;
    border: 1px solid #cccccc;
  }

  .one >>> .el-input__inner:hover, .edit-dialog >>> .el-input__inner:hover {
    font-size: 12px;
    border: 1px solid #b0bceb;
  }

  .one >>> .el-input__inner:focus, .edit-dialog >>> .el-input__inner:focus {
    font-size: 12px;
    border: 1px solid #2b52e9;
    color: #333333;
  }

  /* .one>>>el-table th:focus,.one>>> .el-table tr:focus{
    background-color: red;
  } */
  .one >>> .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #f7f9fc !important;
  }
</style>





// WEBPACK FOOTER //
// src/views/setting/setting.vue